import { ReactElement } from 'react';

import DashboardVariantV2CarrierContentFinalizedTabProvider from './Context';

import {
  DashboardVariantV2CarrierContentTabContainer,
  DashboardVariantV2CarrierContentWrapper,
} from '../../styles';

import {
  DashboardVariantV2CarrierContentFinalizedTabActions,
  DashboardVariantV2CarrierContentFinalizedTabCurrenFilters,
  DashboardVariantV2CarrierContentFinalizedTabDataTable,
} from './Components';

const DashboardVariantV2CarrierContentFinalizedTab = (): ReactElement => (
  <DashboardVariantV2CarrierContentFinalizedTabProvider>
    <DashboardVariantV2CarrierContentTabContainer>
      <DashboardVariantV2CarrierContentFinalizedTabActions />

      <DashboardVariantV2CarrierContentFinalizedTabCurrenFilters />

      <DashboardVariantV2CarrierContentWrapper>
        <DashboardVariantV2CarrierContentFinalizedTabDataTable />
      </DashboardVariantV2CarrierContentWrapper>
    </DashboardVariantV2CarrierContentTabContainer>
  </DashboardVariantV2CarrierContentFinalizedTabProvider>
);

export default DashboardVariantV2CarrierContentFinalizedTab;
